export default function Contact() {
  return (
    <div className="sm:w-2/3 [&>*]:p-4">
      <div>
        <h1 className="text-2xl font-bold font-slate-800">
          Contact Information
        </h1>
      </div>
      <div className="flex flex-col">
        <ul className="list-disc list-outside">
          <li>
            For Support, contact NILO at{" "}
            <a
              className="font-bold text-blue-600 underline"
              href="mailto:support@nilo.win"
            >
              support@nilo.win
            </a>
          </li>
          <li>
            For Athlete Verification, send requisite documentation to{" "}
            <a
              className="font-bold text-blue-600 underline"
              href="mailto:verify@nilo.win"
            >
              verify@nilo.win
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
